import { render, staticRenderFns } from "./MsgList.vue?vue&type=template&id=62d1d243&scoped=true"
import script from "./MsgList.vue?vue&type=script&lang=js"
export * from "./MsgList.vue?vue&type=script&lang=js"
import style0 from "./MsgList.vue?vue&type=style&index=0&id=62d1d243&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d1d243",
  null
  
)

export default component.exports